import React, { useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ReactModal from 'react-modal';

function FamilyMembers() {
    
    const { menu, toggleMobileMenu } = useAppLayout();

    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const loggedInUserId = localStorage.getItem('user_id');
  
    const navigate = useNavigate();
  
    const queryClient = useQueryClient();
  
    const [searchTerm, setSearchTerm] = useState('');
  
    const { data: membersByGeneration, isLoading, isError } = useQuery({
      queryKey: ['familyMembersByGeneration'],
      queryFn: () =>
        axios.get(`${API_URL}/family-members-list`).then((res) => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
    // Prefer relationship-to-current-user; fall back to other likely fields
  const getRelationLabel = (m) => {
    return (
      m?.relation_to_user ||           // e.g. "Granddaughter"
      m?.relationship_to_user ||       // common alt
      m?.relationToMe ||               // camelCase alt
      m?.relationship ||               // plain "relationship"
      m?.relation ||                   // short form
      m?.kinship ||                    // some APIs use this
      m?.role ||                       // last resort
      ''
    );
  };
  
  
    const formatGeneration = (count) => {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const v = count % 100;
      return count + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };
  
  
  
    const calculateAgeDisplay = (dob, dod = null) => {
      if (!dob) return '--';
    
      const birthDate = new Date(dob);
      const endDate = dod ? new Date(dod) : new Date();
    
      let age = endDate.getFullYear() - birthDate.getFullYear();
      const monthDiff = endDate.getMonth() - birthDate.getMonth();
    
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && endDate.getDate() < birthDate.getDate())
      ) {
        age--;
      }
    
      // Guard against invalid or negative ages
      if (age < 0) return '--';
    
      //return dod ? `${age} (deceased)` : age;
  
      return dod
    ? `Died at age ${age} on ${new Date(dod).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })}`
    : `Age ${age}`;
  
    };
  
  
  
  
    const [makeAdminModalOpen, setMakeAdminModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    
    const openMakeAdminModal = (id) => {
      setSelectedUserId(id);
      setMakeAdminModalOpen(true);
    };
  
    const [disableAdminModalOpen, setDisableAdminModalOpen] = useState(false);
  
    const openDisableAdminModal = (id) => {
      setSelectedUserId(id);
      setDisableAdminModalOpen(true);
    };
  
    const handleMakeAdmin = async () => {
      if (!selectedUserId) return;
    
      try {
        const res = await axios.put(
          `${API_URL}/make-member-admin-api`,
          { user_id: selectedUserId },
          { withCredentials: true }
        );
    
        if (res.data.success) {
          toast.success("Admin update successful");
          setMakeAdminModalOpen(false);
          setSelectedUserId(null);
          queryClient.invalidateQueries(['familyMembersByGeneration']);
        } else {
          toast.error(res.data.message || "Failed to update.");
        }
      } catch (error) {
        console.error("Request failed:", error);
        toast.error("Something went wrong.");
      }
    };
    
  
    
  
  
    const handleDisableAdmin = async () => {
      if (!selectedUserId) return;
    
      try {
        const res = await axios.put(
          `${API_URL}/disable-member-admin-api`,
          { user_id: selectedUserId },
          { withCredentials: true }
        );
    
        if (res.data.success) {
          toast.success("Admin update successful");
          setDisableAdminModalOpen(false);
          setSelectedUserId(null);
          queryClient.invalidateQueries(['familyMembersByGeneration']);
        } else {
          toast.error(res.data.message || "Failed to update.");
        }
      } catch (error) {
        console.error("Request failed:", error);
        toast.error("Something went wrong.");
      }
    };
    
  


    const AVATAR_PALETTE = [
      { bg: '#0d6e28', grad: 'linear-gradient(135deg,#e8f5ec,#c8e6d0)' },
      { bg: '#3a5fb0', grad: 'linear-gradient(135deg,#e8f0ff,#c5d5f5)' },
      { bg: '#b07a10', grad: 'linear-gradient(135deg,#fff8e1,#ffe082)' },
      { bg: '#6a3db0', grad: 'linear-gradient(135deg,#f3eeff,#d9c8f5)' },
      { bg: '#0a7a7a', grad: 'linear-gradient(135deg,#e0f7f7,#b2e8e8)' },
      { bg: '#b03030', grad: 'linear-gradient(135deg,#fdf0f0,#f5c6c6)' },
      { bg: '#8a5000', grad: 'linear-gradient(135deg,#fff3e0,#ffcc80)' },
    ];
  
  
    const avatarColor = (name = '') => {
      let hash = 0;
      for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
      return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
    };
  
  
    //const getInitials = (first = '', last = '') => `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
    const getInitials = (first = '', last = '') =>
      `${first?.charAt(0) || ''}${last?.charAt(0) || ''}`.toUpperCase();
  
   

    return (
         
      <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />
<ToastContainer />
         <div className='page-wrapper' >
         <div className='content container-fluid' >

         <div className='row'>
              <div className="col-md-6">
              <div className="text-center mb-2">
                      <h5 className="fw-bold text-dark mb-1">
                      <i className="bi bi-heart-fill text-success me-2"></i>
                      Search member
                      </h5>
                       
                    </div>
                </div>
            
                <div className="col-md-6">
                <div
                        className="input-group rounded-pill overflow-hidden shadow-sm"
                        style={{  background: '#fff' }}
                      >
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search text-muted" />
                        </span>

                        <input
          type="text"
          className="form-control border-0 py-2 small"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ boxShadow: 'none' }}
        />

                        

                        
                      </div> 
                </div>

          </div>

      {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: '50vh' }}
              >
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : isError ? (
              <div className="alert alert-danger text-center">
                Error loading family members.
              </div>
            ) : Object.keys(membersByGeneration || {}).length > 0 ? (
              Object.entries(membersByGeneration)
                .sort(([a], [b]) => a - b)
                .map(([generation_id, members], index) => {
                  const filteredMembers = members.filter((member) =>
                    `${member.name} ${member.last_name}`
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  );

                  if (filteredMembers.length === 0) return null;

                  return (
                    <div key={generation_id} className="mb-5">
                      {/* Generation Header */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span
                          className="badge rounded-pill px-3 py-2"
                          style={{
                            backgroundColor: '#',
                            backgroundColor: '#75B437',
                            color: '#fff',
                          }}
                        >
                          {formatGeneration(index + 1)} Generation
                        </span>

                        {/* Updated members count badge */}
                        <span
                          className="px-3 py-1 small"
                          style={{
                            backgroundColor: 'rgba(0,128,0,0.06)',
                            color: '#2E7D32',
                            borderRadius: '999px',
                            fontWeight: '500',
                          }}
                        >
                          {filteredMembers.length} members
                        </span>
                      </div>

                      {/* Cards */}
                      <div className="row g-3">
                        {filteredMembers.map((member) => {
                          const imagePath = member.image_name
                            ? `${API_URL}/images/${member.image_name}`
                            : `${API_URL}/images/default.png`;

                          return (
                            <div
                              key={member.user_id}
                              className="col-6 col-md-4 col-lg-3"
                            >
                           
                           <div
    style={{
      background: member.date_of_death ? '#fafafa' : '#fff',
      borderRadius: 16,
      border: '0.5px solid #e8e8e8',
      overflow: 'hidden',
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      opacity: member.date_of_death ? 0.85 : 1,
      boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
      transition: 'transform 0.15s, box-shadow 0.15s',
      cursor: 'pointer',
    }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-3px)';
      e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,0,0,0.11)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'none';
      e.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.07)';
    }}
  >
    {/* ── Image / Initials area ── */}
    <div
      style={{ height: 140, position: 'relative', flexShrink: 0, overflow: 'hidden' }}
      onClick={() => navigate('/profile', { state: { memberId: member.id } })}
    >
      {member.profile_image ? (
        <ImageWithLoader2
          src={`${API_URL}/images/${member.profile_image}`}
          placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
          fadeDuration={800}
          blurAmount={15}
          alt={member.name}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      ) : (
        /* Initials fallback */
        (() => {
          const fullName = `${member.name} ${member.last_name}`;
          const color = avatarColor(fullName);
          const initials = getInitials(member.name, member.last_name);
          return (
            <div style={{
              width: '100%', height: '100%',
              background: member.date_of_death
                ? 'linear-gradient(135deg,#f0f0f0,#ddd)'
                : color.grad,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <div style={{
                width: 62, height: 62, borderRadius: '50%',
                background: member.date_of_death ? '#999' : color.bg,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22, fontWeight: 600, color: '#fff',
                boxShadow: `0 4px 14px rgba(0,0,0,0.18)`,
                userSelect: 'none',
              }}>
                {initials}
              </div>
            </div>
          );
        })()
      )}
 
      {/* Admin ribbon */}
      {member.family_admin === 1 && (
        <div style={{
          position: 'absolute', top: 8, left: 0,
          background: 'linear-gradient(135deg,#198754,#0f5132)',
          color: '#fff', fontSize: 9, fontWeight: 600,
          padding: '3px 8px 3px 6px',
          borderRadius: '0 999px 999px 0',
          letterSpacing: '0.03em',
        }}>
          ★ Admin
        </div>
      )}
 
      {/* Deceased strip */}
      {member.date_of_death && (
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          background: 'rgba(0,0,0,0.42)', textAlign: 'center', padding: '3px 0',
        }}>
          <span style={{ fontSize: 10, color: '#fff', letterSpacing: '0.04em' }}>Deceased</span>
        </div>
      )}
    </div>
 
    {/* ── Card body ── */}
    <div
      style={{ padding: '10px 10px 12px', flex: 1 }}
      onClick={() => navigate('/profile', { state: { memberId: member.id } })}
    >
      <p style={{
        fontSize: 13, fontWeight: 600,
        color: member.date_of_death ? '#777' : '#1a1a1a',
        margin: '0 0 2px', whiteSpace: 'nowrap',
        overflow: 'hidden', textOverflow: 'ellipsis',
      }}>
        {member.name} {member.last_name}
      </p>
      <p style={{ fontSize: 11, color: '#888', margin: '0 0 3px' }}>
        {getRelationLabel(member)}
      </p>
      <p style={{
        fontSize: member.date_of_death ? 10 : 11,
        color: member.date_of_death ? '#aaa' : '#555',
        margin: 0, lineHeight: 1.4,
      }}>
        {calculateAgeDisplay(member.date_of_birth, member.date_of_death)}
      </p>
    </div>
 
    {/* ── 3-dot dropdown ── */}
    {loggedFamilyAdmin === '1' && Number(member.id) !== Number(loggedInUserId) && (
      <div
        style={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
        onClick={e => e.stopPropagation()}
      >
         <div className="dropdown">
         <button
                                  className="btn btn-light btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                                  
                                  data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open actions"
                                  style={{ width: 28, height: 28 }}
                                >
            ⋮
          </button>
          <ul className="dropdown-menu dropdown-menu-end p-1"
            style={{ fontSize: 13, minWidth: 150, borderRadius: 10, border: '0.5px solid #e8e8e8' }}>
            {member.family_admin !== 1 && (
              <li>
                <button
                  className="dropdown-item d-flex align-items-center gap-2 py-2 px-2"
                  style={{ color: '#0d6e28', borderRadius: 6 }}
                  onClick={() => openMakeAdminModal(member.id)}
                >
                  <i className="bi bi-shield-check"></i> Make admin
                </button>
              </li>
            )}
            {member.family_admin === 1 && (
              <li>
                <button
                  className="dropdown-item d-flex align-items-center gap-2 py-2 px-2"
                  style={{ color: '#c0392b', borderRadius: 6 }}
                  onClick={() => openDisableAdminModal(member.id)}
                >
                  <i className="bi bi-shield-x"></i> Disable admin
                </button>
              </li>
            )}
          </ul>
        </div>
      </div>
    )}
  </div>


                         


                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })
            ) : (
              <p className="text-center text-muted">
                No family members found.
              </p>
            )}



        </div>
        </div>


          <ReactModal
          isOpen={makeAdminModalOpen}
          onRequestClose={() => setMakeAdminModalOpen(false)}
          className="Modal"
         overlayClassName="Overlay"
        >
          <div className="modal-header">
            <h5 className="modal-title">Make Admin</h5>
            <button
              type="button"
              className="btn-close modalCloseButton"
              onClick={() => setMakeAdminModalOpen(false)}
            />
          </div>
        
          <div className="modal-body">
            <p>
              Are you sure you want to make an admin?
            </p>
          </div>
        
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleMakeAdmin}>
              Yes, Confirm
            </button>
          </div>
        </ReactModal>
        
        
        
        <ReactModal
          isOpen={disableAdminModalOpen}
          onRequestClose={() => setDisableAdminModalOpen(false)}
          className="Modal"
         overlayClassName="Overlay"
        >
          <div className="modal-header">
            <h5 className="modal-title">Disable Admin</h5>
            <button
              type="button"
              className="btn-close modalCloseButton"
              onClick={() => setDisableAdminModalOpen(false)}
            />
          </div>
        
          <div className="modal-body">
            <p>
              Are you sure you want to disable as an admin?
            </p>
          </div>
        
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleDisableAdmin}>
              Yes, Confirm
            </button>
          </div>
        </ReactModal>
        
        

        

        </div>
        
    );
}

export default FamilyMembers;
